import { AxiosInstance } from 'axios'
import { GetStatusHistoryParams, ItemStatusHistory } from './status-history.type'

export class StatusHistoryApi {
    constructor(private readonly client: AxiosInstance) {}

    /**
     * Get status change history for an item (folder or document)
     */
    async list(params: GetStatusHistoryParams): Promise<ItemStatusHistory[]> {
        const response = await this.client.get<ItemStatusHistory[]>('/status-histories', {
            params,
        })
        return response.data
    }
}
